//Retrieve the Full Book

export const makeGetFullBook = db => async (id) => {
  let array = []
  //get all chapters and order them
  try {
    const refPath = `Books/${id}/Chapters`;
    const chapRef = db.collection(refPath).orderBy("index");
    const snapShot = await chapRef.get();
    snapShot.forEach(doc => {
      array.push({ title: doc.id, index: doc.data().index });
    });

    // loop through chapters and retrieve the section reference
    let book = Promise.all(
      array.map(async chap => {
        let chapter = {};
        let sections = [];
        let newPath = `Books/${id}/Chapters/${chap.title}/sections`;
        let sectionsRef = db.collection(newPath).orderBy("dateCreated");
        let result = await sectionsRef.get();
        // grab the sections
        result.forEach(each => {
          sections.push({
            id: each.id,
            text: each.data().text
          });
          //build the book object
          chapter = {
            title: chap.title,
            index: chap.index,
            sections: sections
          };
        });
        return chapter;
      })
    );
    // return an array of all of the chapters of the book
    return book;
  } catch (error) {
    return {
      text: "SOMETHING HAS GONE WRONG",
      error: error
    };
  }
};

export const makeCreateChapter = db => async input => {};
export const makeDeleteChapter = db => async input => {};
export const makeCreateBook = db => async input => {};
export const makeDeleteBook = db => async input => {};

export const makeCreateSection = db => async (book, chap) => {
  const refPath = `Books/${book}/Chapters/${chap}/sections`;
  const ref = db.collection(refPath);
  ref.add({ text: "", dateCreated: Date.now() });
};

export const makeDeleteSection = db => async (book, chap, sec) => {
  const refPath = `Books/${book}/Chapters/${chap}/sections`;
  const ref = db.collection(refPath);
  const result = await ref
    .orderBy("dateCreated", "desc")
    .limit(1)
    .get();
  // prevent deletion of selected section
  if (result.docs[0].id !== sec) {
    const delRef = db
      .collection(refPath)
      .doc(result.docs[0].id)
      .delete();
  } else {
    console.log("please do not delete the section you have currently selected");
  }
};

//Write text to section
export const makeSaveText = db => async (id, chap, sec, data) => {
  const refPath = `Books/${id}/Chapters/${chap}/sections`;
  const ref = db.collection(refPath);
  ref.doc(sec).update({ text: data });
};
//Read text from section
export const makeReadText = db => async (id, chap, sec) => {
  const refPath = `Books/${id}/Chapters/${chap}/sections`;
  const ref = db.collection(refPath);
  const result = await ref.doc(sec).get();
  return result.data();
};



// WEBPACK FOOTER //
// ./src/firebaseFunctions/firebaseFunctions.js